const color = {
  alaWhite: '#f9f9f8',
  midGrey: '#a6a4a0',
  black: '#000000',
  blackish: '#1a1815',
  brass: '#8b735b',
  darkGrey: '#5f5d59',
  lightBrass: '#a48c74',
  lightGrey: '#f0f0ef',
  pastelBrass: '#ded7d0',
  pewter: '#2d2d2f',
  mutedSunset: '#d5cec8',
  white: '#FFFFFF',
};

const breakpoint = {
  tablet: '768px',
  desktop: '992px',
};

export { color, breakpoint };
